module.exports = __webpack_public_path__ + "static/kure1-93e4a5347cdd029e5c25da373378ed61.png";